import { HTMLAttributes, ReactNode, SVGProps, useId } from 'react';
import { twMerge } from 'tailwind-merge';
import { Spec } from '../../ui';

type SpecItem = {
  title: string;
  icon?: (props: SVGProps<SVGSVGElement>) => ReactNode;
  value?: string | ReactNode;
  isHalf?: boolean;
};

type Props = {
  items?: Array<SpecItem>;
  className?: string;
} & Omit<HTMLAttributes<HTMLUListElement>, 'className'>;

export function SpecList(props: Props) {
  const id = useId();
  const { items, className, children, ...rest } = props;

  return (
    <ul className={twMerge('space-y-12', className)} {...rest}>
      {children
        ? children
        : items?.map((item, key) => (
            <Spec key={`spec-list-${id}-item-${key}`} {...item} />
          ))}
    </ul>
  );
}
